// extracted by mini-css-extract-plugin
export default {"pageContent":"Main_pageContent__ro9r8","backButton":"Main_backButton__-F8RG"};